import { useEffect, useState } from "react";
import "./assets/css/style.css";
import Header from "./Components/Header";
import AboutMe from "./Components/AboutMe";
import Resume from "./Components/Resume";
// import Services from './Components/Services';
import Projects from "./Components/Projects";
import Certifications from "./Components/Certifications";
import Contact from "./Components/Contact";
import Credits from "./Components/Credits";
import Home from "./Components/Home";
import AdminLogin from "./Components/AdminLogin";
import NotFound404 from "./Components/404/NotFound404";
import Test from "./Components/Test";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { AuthProvider } from "./Firebase/AuthContext";
import Dashboard from "./Components/Admin/Dashboard";
import PrivateRoute from "./Routes/PrivateRoute";
import {
  getAboutMeData,
  getCertificationsData,
  getHeaderData,
  getProjectsData,
  getResumeData,
  getThemeData,
} from "./Firebase/Firebase";
import { changeColor, changeImage } from "./Helper/CssHelper";
import UnderMaintenance from "./Components/404/UnderMaintenance";

function App() {
  // changeColor("--ElementoMain","#f29810");
  // changeColor("--ElementoMainSection","#f29810")
  // changeColor("--ElementoContainerBackground","rgb(0, 33, 64,0.8")
  // changeImage("--ElementoBackground","url('https://firebasestorage.googleapis.com/v0/b/justin-dsouza.appspot.com/o/WebsiteImages%2Fmclaren720sgt3-4k.jpg?alt=media&token=554c6196-6a20-4c1c-96a9-13bd82b81413')")

  const [HeaderData, setHeaderData] = useState("");
  const [AboutMeData, setAboutMeData] = useState("");
  const [ResumeData, setResumeData] = useState("");
  const [ThemeData, setThemeData] = useState("");
  const [ProjectsData, setProjectsData] = useState("");
  const [CertificationsData, setCertificationsData] = useState("");
  const [ActiveTheme, setActiveTheme] = useState({
    ThemeName: "SestoGreen",
    colors: [
      {
        variable: "--ElementoMain",
        color: "#18d26e",
      },
      {
        variable: "--ElementoMainSection",
        color: "#4ceb95",
      },
      {
        variable: "--ElementoContainerBackground",
        color: "rgba(0, 0, 0, 0.8)",
      },
    ],
    background: {
      variable: "--ElementoBackground",
      url: "url('https://firebasestorage.googleapis.com/v0/b/justin-dsouza.appspot.com/o/WebsiteImages%2FBackgrounds%2FSestoElemento.jpg?alt=media&token=0f5f8427-3598-42f3-9fc5-2c87bccb191e')",
    },
  });
  // console.log(ActiveTheme)

  if (ActiveTheme) {
    ActiveTheme.colors.map((color) => {
      changeColor(color.variable, color.color);
      return null;
    });
    changeImage(ActiveTheme.background.variable, ActiveTheme.background.url);
  }

  async function getData() {
    // console.log("fetching now");
    const Headerdata = getHeaderData();
    Headerdata.then((info) => setHeaderData(info));

    const AboutMedata = getAboutMeData();
    AboutMedata.then((info) => setAboutMeData(info));

    const Resumedata = getResumeData();
    Resumedata.then((info) => setResumeData(info));

    const Projectsdata = getProjectsData();
    Projectsdata.then((info) => setProjectsData(info));

    const Certificationsdata = getCertificationsData();
    Certificationsdata.then((info) => setCertificationsData(info));

    const Themedata = getThemeData();
    Themedata.then((info) => {
      setThemeData(info);
      const ActiveTheme = info.ActiveTheme;
      info.Themes.map((theme) => {
        // console.log(theme.ThemeName)
        if (ActiveTheme === theme.ThemeName) {
          // console.log(theme);
          setActiveTheme(theme);
        }
        return null;
      });
    });
  }

  window.addEventListener("message", function (e) {
    if (window.parentFrame === 0) {
      if (e.data.HeaderData) {
        const Header = e.data.HeaderData;
        setHeaderData(Header);
      }
      if (e.data.AboutMeData) {
        const AboutMeData = e.data.AboutMeData;
        setAboutMeData(AboutMeData);
        // console.log(AboutMeData)
      }
      if (e.data.ResumeData) {
        const ResumeData = e.data.ResumeData;
        setResumeData(ResumeData);
        // console.log(ResumeData);
      }
      if (e.data.ProjectsData) {
        const ProjectsData = e.data.ProjectsData;
        setProjectsData(ProjectsData);
        // console.log(ProjectsData);
      }
      if (e.data.CertificationsData) {
        const CertificationsData = e.data.CertificationsData;
        setCertificationsData(CertificationsData);
        // console.log(CertificationsData);
      }
      if (e.data.ThemeData) {
        const Themes = e.data.ThemeData;
        setThemeData(Themes);
        const ActiveTheme = Themes.ActiveTheme;
        Themes.Themes.map((theme) => {
          // console.log(theme.ThemeName)
          if (ActiveTheme === theme.ThemeName) {
            // console.log(theme);
            setActiveTheme(theme);
          }
          return null;
        });
        // console.log(e.data.ThemeData)
      }
    }
  });

  useEffect(() => {
    getData();
  }, []);

  return (
    <div className="App h-100">
      {!HeaderData.WebsiteUnderMaintenance && (
        <Router>
          <AuthProvider>
            <Header HeaderData={HeaderData} />
            <Switch>
              <Route exact path="/" component={Home} />
              <Route exact path="/AboutMe">
                <AboutMe AboutMeData={AboutMeData} />
              </Route>
              <Route exact path="/Resume">
                <Resume ResumeData={ResumeData} />
              </Route>
              {/* <Route exact path="/Services" component = {Services}/> */}
              <Route exact path="/Projects">
                <Projects ProjectsData={ProjectsData} />
              </Route>
              <Route exact path="/Certifications">
                <Certifications CertificationsData={CertificationsData} />
              </Route>
              <Route exact path="/Contact">
                <Contact HeaderData={HeaderData} />
              </Route>
              <Route exact path="/AdminLogin" component={AdminLogin} />
              <PrivateRoute
                exact
                path="/Admin"
                component={Dashboard}
                HeaderData={HeaderData}
                AboutMeData={AboutMeData}
                ResumeData={ResumeData}
                ThemeData={ThemeData}
                ProjectsData={ProjectsData}
                CertificationsData={CertificationsData}
              />
              <Route exact path="/test" component={Test} />
              <Route component={NotFound404} />
            </Switch>
            <Credits />
          </AuthProvider>
        </Router>
      )}
      {HeaderData.WebsiteUnderMaintenance && (
        <Router>
          <Switch>
            <Route exact path="/">
              <UnderMaintenance HeaderData={HeaderData} />
            </Route>
          </Switch>
        </Router>
      )}
    </div>
  );
}

export default App;
